module.exports = __webpack_public_path__ + "static/media/IMAGE-4-FOREST-FLOOR-desktop.acbca700.jpg";